import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 7h1.998v6.996H11V7zM12.998 17v-2.005H11V17h1.998z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.414 2.586L2.586 7.414A2 2 0 002 8.828v6.344a2 2 0 00.586 1.414l4.828 4.828A2 2 0 008.828 22h6.344a2 2 0 001.414-.586l4.828-4.828A2 2 0 0022 15.172V8.828a2 2 0 00-.586-1.414l-4.828-4.828A2 2 0 0015.172 2H8.828a2 2 0 00-1.414.586zM4 8.828L8.828 4h6.344L20 8.828v6.344L15.172 20H8.828L4 15.172V8.828z"
      fill="currentColor"
    />
  </svg>
);
